<template>
  <div class="content_view">
    <div class="main" v-if="isVip == true">
      <div class="examin_head">
        <el-form
          :label-position="labelPosition"
          label-width="90px"
          :model="formLabelAlign"
          ref="formLabelAlign"
        >
          <el-form-item label="培训名称：" prop="name">
            <el-input
              v-model.trim="formLabelAlign.name"
              placeholder="请输入考试名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="培训状态：" prop="state">
            <el-select
              v-model="formLabelAlign.state"
              label="全部"
              @change="searchChang"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in stateArr"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="培训时间：" prop="value3">
            <el-date-picker
              v-model="examTime"
              @change="searchChang"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div class="query_btn">
          <el-button
            type="primary"
            icon="el-icon-search"
            class="searchbtn"
            @click="searchBtn"
            >搜索</el-button
          >
          <el-button
            icon="el-icon-refresh"
            class="searchbtn sonbtn"
            @click="resetForm('formLabelAlign')"
            >重置</el-button
          >
        </div>
      </div>
      <div class="batch_box">
        <el-button @click="addTask">
          <i class="el-icon-upload"></i>新建学习任务</el-button
        >
      </div>
      <!-- 表格 -->
      <div class="hos_table" v-loading="loading">
        <el-table
          :data="getData"
          ref="multipleTable"
          style="width: 100%"
          :cell-class-name="stateColor"
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            'background-color': '#8FCBFF',
            color: '#333333',
            height: '60px',
          }"
        >
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in formColumns"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            height="150"
            label-height="50"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="address"
            label="操作"
            align="center"
            width="406"
          >
            <template slot-scope="scope">
              <div class="operation_box">
                <el-button
                  type="text"
                  size="small"
                  @click="modifyTraining(scope.row)"
                  >修改培训</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="arrangeTask(scope.row)"
                  >配置任务</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="detailsTrainin(scope.row)"
                  >培训详情</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="deleteTraining(scope.row)"
                  >删除培训</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="foot_box">
        <div class="foot_pagetions">
          <p>共有{{ total }}条记录，当前第{{ currentPage }}/{{ pagesun }}页</p>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="showpageindex"
            :page-size="pageSize"
            :page-sizes="pagesizesarr"
            layout="prev, pager, next,sizes, jumper"
            :total="total"
            class="pagination"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <Maskdomo v-else />
  </div>
</template>

<script>
import training from "@/api/trainingApi";
import Maskdomo from "./Maskdomo.vue";
export default {
  data() {
    return {
      formLabelAlign: {
        name: "", //名称
        state: "", // 状态
        createBeginTime: "", //时间
        createEndTime: "", // 结束时间
      },
      getDataCondition: {
        name: "",
      },
      getData: [],
      labelPosition: "right",
      examTime: "",
      showpageindex: 1, //显示的索引盒子
      currentPage: 1, //  当前页数
      pageSize: 10, //每页的条数
      pagesizesarr: [5, 10, 20, 50, 100],
      pagesun: "", //一共多少页
      total: 100,
      loading: false,
      stateArr: [
        {
          label: "未开始",
          value: "0",
        },
        {
          label: "进行中",
          value: "1",
        },
        {
          label: "已结束",
          value: "2",
        },
      ],
      formColumns: [
        {
          prop: "name",
          label: "培训名称",
        },
        {
          prop: "trainStatus",
          label: "培训状态",
        },
        {
          prop: "begainTime1",
          width: "300px",
          label: "培训时间",
        },
        {
          prop: "createTime",
          label: "创建时间",
        },
      ],
      isVip: false,
    };
  },
  props: ["cutcoms"],
  components: {
    Maskdomo,
  },
  activated() {
    this.init();
  },
  methods: {
    async init() {
      // 查看是否有权限开通
      const { data } = await training.checkPower({});
      if (data.Status == 200) {
        this.isVip = data.Data.isOpenTrain;
        if (data.Data.isOpenTrain == true) {
          this.getDatalist();
          sessionStorage.removeItem("deleteArr");
          sessionStorage.removeItem("stateMenuList");
          if (this.$route.query.trainId) {
            this.$parent.examRow.trainId = this.$route.query.trainId;
            if (this.$route.query.state) {
              this.$parent.examRow = JSON.parse(
                sessionStorage.getItem("examRow")
              );
              this.$parent.type = 0;
              this.cutcoms(6);
            } else {
              this.cutcoms(3);
            }
          } else {
            localStorage.removeItem("examRowTime");
          }
        }
      } else {
        this.$message({
          message: data.Data,
          type: "warning",
        });
      }
    },
    // 新增
    addTask() {
      this.$parent.operateState = 0;
      this.cutcoms(1);
    },
    searchChang() {
      this.currentPage = 1;
      if (this.examTime == null) {
        this.formLabelAlign.createBeginTime = "";
        this.formLabelAlign.createEndTime = "";
      }
      this.getDatalist();
    },
    // 搜索
    searchBtn() {
      this.currentPage = 1;
      this.loading = true;
      if (this.formLabelAlign.name) {
        this.getDataCondition.name = this.formLabelAlign.name;
      } else {
        this.getDataCondition.name = "";
      }
      this.getDatalist();
    },
    // 重置
    resetForm(formExamin) {
      this.loading = true;
      this.examTime = "";
      this.showpageindex = 1;
      this.formLabelAlign.name = "";
      this.getDataCondition.name = "";
      this.formLabelAlign.createBeginTime = "";
      this.formLabelAlign.createEndTime = "";
      this.currentPage = 1;
      this.getDatalist();
    },
    // 修改培训
    modifyTraining(row) {
      this.$parent.examRow = row;
      this.$parent.operateState = 1;
      this.cutcoms(1);
    },
    // 配置任务
    arrangeTask(row) {
      this.$parent.examRow = row;
      localStorage.setItem("examRowTime", JSON.stringify(this.$parent.examRow)); // 记录培训时间限制
      this.cutcoms(3);
    },
    // 培训详情
    async detailsTrainin(row) {
      this.$parent.examRow = row;
      this.$parent.type = 0;
      sessionStorage.setItem("examRow", JSON.stringify(row));
      localStorage.setItem("examRowTime", JSON.stringify(this.$parent.examRow)); // 记录培训时间限制
      this.cutcoms(6);
      return;
      const obj = {
        trainId: row.tranid,
      };
      const { data } = await training.getTrainByID(obj);
      console.log(data);
    },
    // 删除培训
    deleteTraining(row) {
      this.$confirm("此操作将永久删除该培训, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const obj = {
            trainId: row.tranid,
          };
          const { data } = await training.deleteTraining(obj);
          if (data.Status == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getDatalist();
          } else {
            this.$message({
              message: data.Data,
              type: "warning",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getDatalist() {
      if (this.examTime) {
        const time = JSON.parse(JSON.stringify(this.examTime));
        this.formLabelAlign.createBeginTime = this.$moment(time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formLabelAlign.createEndTime = this.$moment(time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      this.loading = true;
      const obj = {
        name: this.getDataCondition.name,
        status: this.formLabelAlign.state, // 进行中 未开始 已结束
        begainTime: this.formLabelAlign.createBeginTime,
        endTime: this.formLabelAlign.createEndTime,
        pageNum: this.currentPage - 1,
        pageSize: this.pageSize,
      };
      const { data } = await training.getTrainList(obj);
      if (data.Status == 200) {
        this.getData = data.Data.list.map((item) => {
          item.begainTime1 =
            this.$moment(item.begainTime).format("YYYY-MM-DD") +
            "-" +
            this.$moment(item.endTime).format("YYYY-MM-DD");
          return item;
        });
        this.total = data.Data.total;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else {
        this.$message({
          message: data.Data,
          type: "warning",
        });
      }
      console.log(data);
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.loading = true;
      this.getDatalist(); // 重新发起请求
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.loading = true;
      this.getDatalist();
    },
    // 表格样式设置
    stateColor({ row, column, rowIndex, columnIndex }) {
      if (row.AnIsPublish === "未开始" && columnIndex === 6) {
        return "yellow";
      } else if (row.AnIsPublish === "进行中" && columnIndex === 6) {
        return "red";
      } else if (row.AnIsPublish === "已结束" && columnIndex === 6) {
        return "green";
      }
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  background-color: #ffffff;
  width: 100%;
  //   height: 100%;
  min-height: 780px;
}
.examin_head {
  padding: 30px 24px 10px 10px;
  display: flex;
  flex-wrap: wrap;
  ::v-deep .el-form {
    display: flex;
    flex-wrap: wrap;
    .el-form-item {
      &:nth-child(3) {
        .el-input__inner:nth-child(1) {
          width: 340px;
        }
      }
    }
    .el-input__inner:nth-child(1) {
      width: 168px;
    }
  }

  .query_btn {
    display: flex;
    .el-button {
      width: 88px;
      height: 40px;
      margin-left: 24px;
      &:nth-child(3) {
        background: #409eff;
        color: #fff;
        width: 120px;
      }
    }
  }
}
::v-deep .el-range-separator {
  color: #eeeeee !important;
}
.examinee_form {
  padding: 0px 20px 0px 34px;
  p {
    margin-bottom: 16px;
  }
}
.batch_box {
  padding: 0px 24px;
  margin: 24px 0px;
  .el-button {
    width: 141px;
    height: 40px;
    color: #ffffff;
    background: #64b5ff;
  }
  span > i {
    font-size: 14px !important;
    margin-right: 5px;
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
// 分页
.foot_box {
  position: relative;
  height: 86px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}
.hos_table {
  padding: 24px;
}
::v-deep .cell {
  text-align: center;
}
.el-button--text {
  font-size: 16px;
}
</style>